/**
 * We do this because tomcat decodes automatically, and so does the load
 * balancer, so in order for the text to get through we need to encode
 * everything in the url twice
 */
export default function doubleEncode(string) {
  return encodeURIComponent(encodeURIComponent(string));
}
